export { default as RecentItemsCarousel } from './recent-items-carousel';
